import { render, staticRenderFns } from "./CameraButton.vue?vue&type=template&id=567eaa07&scoped=true"
import script from "./CameraButton.vue?vue&type=script&lang=js"
export * from "./CameraButton.vue?vue&type=script&lang=js"
import style0 from "./CameraButton.vue?vue&type=style&index=0&id=567eaa07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567eaa07",
  null
  
)

export default component.exports